import {
  Application,
  OutgoingApplication,
  Offer,
  Disclosure,
} from '@ads-bread/shared/bread/codecs';
import { APIFetch, APIResponse } from '../hooks/apiFetch';
import { HandlerResponse, handleResponse } from './base';

export const APPLICATION_URI = '/api/application';

interface ApplicationCheckoutOptions {
  application: Application;
  shippingContactID: string;
  disclosures: Disclosure[];
  selectedOffer: Offer;
  iovationBlackboxId?: string | null;
  paymentMethodID?: string;
  autoPaymentMethodID?: string;
  decibelSessionId?: string;
}

export async function applicationCheckout(
  {
    application,
    shippingContactID,
    disclosures,
    selectedOffer,
    iovationBlackboxId,
    paymentMethodID,
    autoPaymentMethodID,
    decibelSessionId,
  }: ApplicationCheckoutOptions,
  apiFetch: APIFetch
): Promise<HandlerResponse<Application>> {
  const dedupedDisclosures = [
    ...new Map(
      [...(application?.disclosures || []), ...disclosures].map(
        (disclosure) => [disclosure.type, disclosure]
      )
    ).values(),
  ];

  const body = {
    ...application,
    buyerShippingContactID: shippingContactID,
    disclosures: dedupedDisclosures,
    paymentMethodID,
    autoPaymentMethodID,
  };

  const clientInfo = [];

  if (iovationBlackboxId) {
    clientInfo.push({
      type: 'iovationBlackbox',
      value: iovationBlackboxId,
    });
  }

  if (decibelSessionId) {
    clientInfo.push({
      type: 'decibel_session_id',
      value: decibelSessionId,
    });
  }

  body.clientInfo = clientInfo;

  const res: APIResponse<Application> = await apiFetch<
    Application,
    OutgoingApplication
  >(
    `${APPLICATION_URI}/${application?.id}/agreement/${selectedOffer.paymentAgreement.id}/checkout`,
    { body },
    Application
  );
  return handleResponse(res);
}
